import ThisModule from "./PricesSection";

export default ThisModule;
